<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-account-plus
            </v-icon>
            <span class="title">Registration</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text>
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab href="#mahasiswa">
              Mahasiswa
              <v-icon large>mdi-school</v-icon>
            </v-tab>
            <v-tab href="#dosen">
              Dosen
              <v-icon large>mdi-account-tie-outline</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <!-- jobseeker -->
            <v-tab-item value="mahasiswa">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="5">
                        <div class="mb-5">
                          <h2 class="text-md-h5">
                            Registrasi mahasiswa
                          </h2>
                        </div>
                        <div class="mb-3">
                          <div class="foot-list-icon float-left">
                            <v-icon :color="maincolor">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </div>
                          <div class="foot-list-content">
                            Stay connected with relevant course
                          </div>
                        </div>
                        <div class="mb-5">
                          <div class="foot-list-icon float-left">
                            <v-icon :color="maincolor">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </div>
                          <div class="foot-list-content">
                            Get course that are more relevant to you delivered daily
                          </div>
                        </div>
                        <div class="mb-3">
                          <p>
                            By signing up, I have read and agreed to elearning.pnb.ac.id <br>
                            Terms of Use and Privacy Policy.
                          </p>
                        </div>
                      </v-col>
                      <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                        <v-divider vertical></v-divider>
                      </v-col>
                      <v-col cols="12" md="5">
                        <div class="mb-5">
                          <h2 class="text-md-h5">
                            Buat akun mahasiswa
                          </h2>
                          <p>
                            Log in dengan akun mahasiswa mengikuti perkuliahan daring.
                          </p>
                        </div>
                        <v-form
                          @submit.prevent="submitRegjobseeker"
                          ref="formregjobseeker"
                          v-model="formadd.jobseeker"
                          lazy-validation>
                          <v-row justify="center" no-gutters>
                            <v-col cols="12" md="12">
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    dense
                                    v-model="regjobseeker.firstname"
                                    :rules="[rules.required]"
                                    label="First name *"
                                    name="firstnama"
                                    required>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    dense
                                    v-model="regjobseeker.lastname"
                                    :rules="[rules.required]"
                                    label="Last Nama *"
                                    name="lastnama"
                                    required>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    dense
                                    v-model="regjobseeker.nim"
                                    :rules="[rules.required]"
                                    label="NIM *">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    dense
                                    v-model="regjobseeker.email"
                                    :rules="[rules.required, rules.email]"
                                    label="E-mail *">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    dense
                                    v-model="regjobseeker.password"
                                    :append-icon="formadd.passwordjs ? 'visibility' : 'visibility_off'"
                                    :rules="[rules.required, rules.minpass]"
                                    :type="formadd.passwordjs ? 'text' : 'password'"
                                    name="password"
                                    label="Password"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="formadd.passwordjs = !formadd.passwordjs">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <alertsp :alertdata="alertregjs"></alertsp>
                                  <v-btn
                                    large
                                    block
                                    :loading="loading.regjs"
                                    :disabled="loading.regjs || !formadd.jobseeker"
                                    :color="maincolor"
                                    class="mr-4 mt-3 white--text"
                                    type="submit">
                                    Sign Up
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                  Already a member?
                                  <router-link :to="{ name: 'Login' }">
                                    Log in Now
                                  </router-link>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!-- company -->
            <v-tab-item value="dosen">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center" class="black--text">
                      <v-col cols="12" md="5">
                        <div class="mb-5">
                          <h2 class="text-md-h5">
                            Registrasi dosen
                          </h2>
                        </div>
                        <div class="mb-3">
                          <div class="foot-list-icon float-left">
                            <v-icon :color="maincolor">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </div>
                          <div class="foot-list-content">
                            Stay connected with relevant course
                          </div>
                        </div>
                        <div class="mb-5">
                          <div class="foot-list-icon float-left">
                            <v-icon :color="maincolor">
                              mdi-checkbox-marked-outline
                            </v-icon>
                          </div>
                          <div class="foot-list-content">
                            Get course that are more relevant to you delivered daily
                          </div>
                        </div>
                        <div class="mb-3">
                          <p>
                            By signing up, I have read and agreed to elearning.pnb.ac.id <br>
                            Terms of Use and Privacy Policy.
                          </p>
                        </div>
                      </v-col>
                      <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                        <v-divider vertical></v-divider>
                      </v-col>
                      <v-col cols="12" md="5">
                        <div class="mb-5">
                          <h2 class="text-md-h5">
                            Buat akun dosen
                          </h2>
                          <p>
                            Log in dengan akun dosen untuk mengelola perkuliahan daring.
                          </p>
                        </div>
                        <v-form
                          @submit.prevent="submitRegcompany"
                          ref="formregcompany"
                          v-model="formadd.company"
                          lazy-validation>
                          <v-row justify="center" no-gutters>
                            <v-col cols="12" md="12">
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    dense
                                    v-model="regcompany.nip"
                                    :rules="[rules.required]"
                                    label="NIP *"
                                    name="nip">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    dense
                                    v-model="regcompany.firstname"
                                    :rules="[rules.required]"
                                    label="First name *"
                                    name="firstnama"
                                    required>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    dense
                                    v-model="regcompany.lastname"
                                    :rules="[rules.required]"
                                    label="Last name *"
                                    name="lastnama"
                                    required>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    dense
                                    v-model="regcompany.email"
                                    :rules="[rules.required, rules.email]"
                                    label="E-mail *"
                                    name="email">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    dense
                                    v-model="regcompany.password"
                                    :append-icon="formadd.password ? 'visibility' : 'visibility_off'"
                                    :rules="[rules.required, rules.minpass]"
                                    :type="formadd.password ? 'text' : 'password'"
                                    name="password"
                                    label="Password"
                                    hint="At least 8 characters"
                                    counter
                                    @click:append="formadd.password = !formadd.password">
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <alertsp :alertdata="alertdata"></alertsp>
                                  <v-btn
                                    large
                                    block
                                    :loading="loading.regcom"
                                    :disabled="loading.regcom || !formadd.company"
                                    :color="maincolor"
                                    class="mr-4 mt-3 white--text"
                                    type="submit">
                                    Sign Up
                                  </v-btn>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                  Already a member?
                                  <router-link :to="{ name: 'Login' }">
                                    Log in Now
                                  </router-link>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.jeniskerja"
      max-width="600px"
      v-if="dmodaldata.jeniskerja">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis pekerjaan</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <alertsp :alertdata="alertupdate"></alertsp>
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejeniskerja"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jeniskerja.nama_kerja"
                        :rules="[rules.required]"
                        label="Nama"
                        name="nama"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="dmodaldata.jeniskerja.deskripsi_kerja"
                        auto-grow
                        label="Deskripsi jenis pekerjaan"
                        rows="1">
                      </v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statuskerja"
                        v-model="dmodaldata.jeniskerja.status_kerja"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('jeniskerja')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Register',
  data: () => ({
    alertregjs: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      regjs: false,
      regcom: false,
      getdata: false,
    },
    publickey: '123',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    regjobseeker: {
      firstname: '',
      lastname: '',
      nim: '',
      email: '',
      password: '',
    },
    regcompany: {
      firstname: '',
      lastname: '',
      nip: '',
      email: '',
      password: '',
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      jobseeker: false,
      company: false,
      passwordjs: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    // this.getJeniskerja();
    if (this.$route.query.tab && this.$route.query.tab !== '') {
      this.tabdata = this.$route.query.tab;
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitRegcompany() {
      this.alertdata.show = false;
      if (this.$refs.formregcompany.validate()) {
        if (this.publickey) {
          // console.log(this.regcompany);
          this.loading.regcom = true;
          this.axios
            .post(
              this.api + '/api/auth/regcompany',
              qs.stringify(
                this.regcompany,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.publickey,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                // console.log(res);
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formregcompany.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Congratulations <br/> your account already created <br/>';
                  // this.alertdata.text += 'Please verify your email <br/> "' + resdata.data + '"<br/> Thank you';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.regcom = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.regcom = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    submitRegjobseeker() {
      this.alertregjs.show = false;
      if (this.$refs.formregjobseeker.validate()) {
        if (this.publickey) {
          // console.log(this.regjobseeker);
          this.loading.regjs = true;
          this.axios
            .post(
              this.api + '/api/auth/regjobseeker',
              qs.stringify(
                this.regjobseeker,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.publickey,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formregjobseeker.reset();
                  this.alertregjs.show = true;
                  this.alertregjs.type = 'success';
                  this.alertregjs.text = 'Congratulations <br/> your account already created <br/>';
                  // this.alertregjs.text += 'Please verify your email <br/> "' + resdata.data + '"<br/> Thank you';
                } else {
                  this.alertregjs.show = true;
                  this.alertregjs.type = 'error';
                  this.alertregjs.text = resdata.message;
                }
              } else {
                this.alertregjs.show = true;
                this.alertregjs.type = 'error';
                this.alertregjs.text = 'Internal services error!';
              }
              this.loading.regjs = false;
            })
            .catch((error) => {
              this.alertregjs.show = true;
              this.alertregjs.type = 'error';
              this.alertregjs.text = 'Internal services error!';
              this.loading.regjs = false;
            });
        } else {
          this.alertregjs.show = true;
          this.alertregjs.type = 'error';
          this.alertregjs.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
